module.exports = "<span class=\"text-success\"\n  *ngIf=\"isTruthy()\">\n  <i class=\"fa fa-check\"></i>\n</span>\n";